module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-report-2.8276525f.svg";